import { render, staticRenderFns } from "./WorkflowSearchTermsExtractionModal.vue?vue&type=template&id=3eeb071a"
import script from "./WorkflowSearchTermsExtractionModal.vue?vue&type=script&lang=js"
export * from "./WorkflowSearchTermsExtractionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eeb071a')) {
      api.createRecord('3eeb071a', component.options)
    } else {
      api.reload('3eeb071a', component.options)
    }
    module.hot.accept("./WorkflowSearchTermsExtractionModal.vue?vue&type=template&id=3eeb071a", function () {
      api.rerender('3eeb071a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowSearchTermsExtractionModal.vue"
export default component.exports